export enum EventPoolMode {
  SingleMode = 101,
  DuelMode = 102,
  LeagueMode = 103,
  TournamentMode = 104
}

export enum EventPoolStatus {
  Opened = 101,
  Closed = 102,
  Filled = 200
}